<h1>{{ 'LEAD_INTEGRATIONS.FACEBOOK.PAGE_PICKER.TITLE' | translate }}</h1>
<p>{{ 'LEAD_INTEGRATIONS.FACEBOOK.PAGE_PICKER.DESCRIPTION' | translate }}</p>
<va-mat-table>
  <table mat-table [dataSource]="dataSource$ | async">
    <ng-container matColumnDef="name">
      <mat-radio-group (change)="emitPage($event.value)">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'LEAD_INTEGRATIONS.FACEBOOK.PAGE_PICKER.NAME_COLUMN' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-radio-button
            [value]="element.id"
            [disabled]="!element.canSubscribeLeadWebhooks"
            color="primary"
          >
            {{ element.name }}
          </mat-radio-button>
        </td>
      </mat-radio-group>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'LEAD_INTEGRATIONS.FACEBOOK.PAGE_PICKER.ID_COLUMN' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
    </ng-container>

    <ng-container matColumnDef="hasPermissions">
      <th mat-header-cell *matHeaderCellDef>
        {{
          'LEAD_INTEGRATIONS.FACEBOOK.PAGE_PICKER.PERMISSIONS_COLUMN'
            | translate
        }}
      </th>
      <td mat-cell *matCellDef="let element">
        <app-facebook-page-picker-permissions-cell
          [hasPermissions]="element.canSubscribeLeadWebhooks"
        ></app-facebook-page-picker-permissions-cell>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</va-mat-table>
